import { AvatarWithLabel } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { StyledButton } from './styled';
export function DocumentName(props) {
    const { name, onClick } = props;
    return (<StyledButton type="button" onClick={onClick}>
      <AvatarWithLabel truncate shape="square" size="sm" appearance="light" title={name}>
        <Falcon icon="file"/>
      </AvatarWithLabel>
    </StyledButton>);
}
